// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import type { SafeObjectChange } from '@safecoin/safe/jsonRpc';

export const getOwnerType = (change: SafeObjectChange): string => {
	if (!('owner' in change)) return '';
	if (typeof change.owner === 'object') {
		if ('AddressOwner' in change.owner) return 'AddressOwner';
		if ('ObjectOwner' in change.owner) return 'ObjectOwner';
		if ('Shared' in change.owner) return 'Shared';
		if ('ConsensusAddressOwner' in change.owner) return 'ConsensusAddressOwner';
	}
	return String(change.owner);
};
